import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const EventCtx = createContext(null);

const STORAGE_KEY = "st_current_event_id";

export function EventProvider({ children }) {
  const [events, setEvents] = useState([]);
  const [currentEventId, setCurrentEventIdRaw] = useState(null);
  const [loading, setLoading] = useState(true);

  const setCurrentEventId = useCallback((id) => {
    setCurrentEventIdRaw(id);
    try {
      if (id) localStorage.setItem(STORAGE_KEY, id);
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* ignore */ }
  }, []);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/events");
      const list = r.data || [];
      // sort: published first, then by created_at desc — most recent first
      list.sort((a, b) => {
        const sa = a.status === "published" ? 0 : 1;
        const sb = b.status === "published" ? 0 : 1;
        if (sa !== sb) return sa - sb;
        return (b.created_at || "").localeCompare(a.created_at || "");
      });
      setEvents(list);
      // pick selection: stored ID if still valid, else most recent
      const stored = (() => { try { return localStorage.getItem(STORAGE_KEY); } catch { return null; } })();
      const valid = list.find(e => e.id === stored);
      const next = valid ? valid.id : (list[0]?.id || null);
      setCurrentEventIdRaw(next);
      try { if (next) localStorage.setItem(STORAGE_KEY, next); } catch (e) { /* ignore */ }
    } catch (e) {
      setEvents([]);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const currentEvent = events.find(e => e.id === currentEventId) || null;

  return (
    <EventCtx.Provider value={{
      events, currentEventId, currentEvent, loading,
      setCurrentEventId, refresh,
    }}>
      {children}
    </EventCtx.Provider>
  );
}

export const useEvent = () => useContext(EventCtx);
